module.exports = __webpack_public_path__ + "img/zcwjcolor.c0c6aab8.png";